/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:07:05
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-03-28 09:56:57
 */
import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help"
import Konva from "konva"
import { getImgSrcByName } from "@/topo/core/utils/img-load.js"

class TransformerElement extends GraphElement {
  static fromJSON = createFromJSON(this)

  constructor(topology, x, y, attrs) {
    super(topology, 'transformer', x, y, {
      text: '变压器',
      port: true,
      useTransparentImg: true,
      ...attrs
    })

    this.onLoad(() => {
      this.prop_y = 0
      this.prop_x = 50
      this.addInnerShape()
      // 属性
      this.addProperty('功率', 'kW')
      this.addProperty('无功功率', 'kvar')
      this.addProperty('电流', 'A')
      this.addProperty('电压', 'V')
    })

    this.isOverload = false
  }

  updateData(data) {
    this.isOverload = data.isOverload
    this.updateProperty('功率', data.p)
    this.updateProperty('无功功率', data.q)
    this.updateProperty('电流', data.i_a)
    this.updateProperty('电压', data.u_ab)
  }

  addInnerShape() {
    Promise.all([
      this.imageNodeFromName('tfmNormal'),
      this.imageNodeFromName('tfmOverload'),
    ]).then(([normal, overload]) => {
      // console.log('a', normal, overload)
      normal.show()
      this.normalNode = normal
      this.overloadNode = overload

      let num = 0
      let t = setInterval(() => {
        if (this.isOverload) {
          this.setOverloadState(num++)
        } else {
          this.setNormalState()
        }
        if (num >= 1000) {
          num = 0
        }
      }, 500)

      this.onRemove(() => {
        clearInterval(t)
      })
    })
  }


  setOverloadState(num) {
    this.normalNode.hide()
    if (num % 5 === 0) {
      this.overloadNode.hide()
    } else {
      this.overloadNode.show()
    }
  }

  setNormalState() {
    this.normalNode.show()
    this.overloadNode.hide()
  }

  imageNodeFromName(imgName) {
    const imgSrc = getImgSrcByName(imgName)
    return new Promise((resolve, reject) => {
      Konva.Image.fromURL(imgSrc, (darthNode) => {
        darthNode.setAttrs({
          x: 6,
          y: 6,
          visible: false,
          width: 24,
          height: 39,
        })
        this.g.add(darthNode)
        resolve(darthNode)
      }, reject)
    })
  }

}


export { TransformerElement }
